import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AdminService } from './api/admin.service';
import { EntriesService } from './api/entries.service';
import { EntryCodeErrorCodeCausesService } from './api/entryCodeErrorCodeCauses.service';
import { EntryCodeErrorCodesService } from './api/entryCodeErrorCodes.service';
import { EntryCodesService } from './api/entryCodes.service';
import { MouldsService } from './api/moulds.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class MouldLogApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<MouldLogApiModule> {
        return {
            ngModule: MouldLogApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: MouldLogApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('MouldLogApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
